import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading } from "@/components/ui-kit";
import { PenLine, CheckCircle2, Clock, ChevronRight } from "lucide-react";
import { fmtDue } from "@/lib/due";

export default function WritingIndex() {
  const [hws, setHws] = useState(null);
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    api.get("/homework").then((r) => setHws(r.data.filter((h) => h.questions?.[0]?.type === "writing")));
    api.get("/writing").then((r) => setSubs(r.data));
  }, []);
  if (!hws || !subs) return <Loading />;

  const subFor = (hwId) => subs.find((s) => s.homework_id === hwId);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Writing" subtitle="Complete your writing tasks and read tutor feedback." />
      {hws.length === 0 ? (
        <div className="ember-card py-16 text-center text-sm text-[#948EAB]">No writing tasks released yet.</div>
      ) : (
        <div className="grid gap-3">
          {hws.map((h) => {
            const s = subFor(h.id);
            const reviewed = s?.status === "reviewed";
            const submitted = s?.status === "submitted";
            return (
              <Link key={h.id} to={`/student/writing/${h.id}`} data-testid={`writing-task-${h.id}`} className="ember-card ember-card-hover flex items-center gap-4 p-5">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#FFF1F2] text-[#E11D48]"><PenLine className="h-5 w-5" /></span>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-heading font-bold text-[#1E1B2E]">{h.title}</div>
                  <div className="text-xs text-[#948EAB]">{h.section_name}{h.due_date ? ` · ${fmtDue(h.due_date)}` : ""}</div>
                </div>
                {reviewed ? <span className="inline-flex items-center gap-1 rounded-full bg-[#ECFDF5] px-2.5 py-1 text-xs font-bold text-[#059669]"><CheckCircle2 className="h-3.5 w-3.5" /> Feedback ready</span>
                  : submitted ? <span className="inline-flex items-center gap-1 rounded-full bg-[#FFFBEB] px-2.5 py-1 text-xs font-bold text-[#B45309]"><Clock className="h-3.5 w-3.5" /> Submitted</span>
                  : <ChevronRight className="h-5 w-5 text-[#C4B5FD]" />}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
